import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { initials } from '@/lib/clinic/format'

const TONES = [
    'bg-teal-100 text-teal-800',
    'bg-sky-100 text-sky-800',
    'bg-indigo-100 text-indigo-800',
    'bg-emerald-100 text-emerald-800',
    'bg-amber-100 text-amber-900',
    'bg-rose-100 text-rose-800',
    'bg-cyan-100 text-cyan-800',
    'bg-violet-100 text-violet-800'
]

const SIZES = {
    sm: 'size-8 text-[0.7rem]',
    md: 'size-10 text-sm',
    lg: 'size-14 text-lg',
    xl: 'size-16 text-xl'
}

const toneFor = (seed: string): string => {
    let hash = 0

    for (const character of seed) hash = (hash * 31 + character.charCodeAt(0)) >>> 0

    return TONES[hash % TONES.length]
}

interface PatientAvatarProps {
    name: string
    seed?: string
    size?: keyof typeof SIZES
    className?: string
}

export const PatientAvatar: FC<PatientAvatarProps> = ({ name, seed, size = 'md', className }): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn(
                'flex shrink-0 items-center justify-center rounded-full font-semibold tracking-wide select-none',
                SIZES[size],
                toneFor(seed || name),
                className
            )}
        >
            {initials(name)}
        </span>
    )
}
